import type { StartResponse, SendResponse } from '../types';

async function request<T>(path: string, body: unknown): Promise<T> {
  const apiRoot = window.grippyWidget.apiRoot.replace(/\/$/, '');
  const res = await fetch(`${apiRoot}/${path.replace(/^\//, '')}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'omit',
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`chat request failed: ${res.status} ${text.slice(0, 120)}`);
  }
  return (await res.json()) as T;
}

export const chatApi = {
  start: (visitorId: string, pageUrl: string, locale: string) =>
    request<StartResponse>('chat/start', { visitor_id: visitorId, page_url: pageUrl, locale }),

  send: (conversationUuid: string, visitorId: string, message: string) =>
    request<SendResponse>('chat/message', {
      conversation_uuid: conversationUuid,
      visitor_id: visitorId,
      message,
    }),
};
